import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-132c0227"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Available Reports", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { href: "#" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("All User Information")
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { href: "#" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("All Sessions")
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { href: "#" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Session Events Timeline ")
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_download = _resolveDirective("download")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", null, [
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, _hoisted_5)), [
              [_directive_download, 'reports/users']
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, _hoisted_8)), [
          [_directive_download, 'reports/sessions']
        ])
      ]),
      _createElementVNode("li", null, [
        _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, _hoisted_11)), [
          [_directive_download, 'reports/session-events']
        ])
      ])
    ])
  ], 64))
}